import { connect } from 'react-redux';
import { compose } from 'recompose';

import LeaseTable from './LeaseTable';
import {
  openLeaseEditModal,
  openLeaseMoveModal,
  openLeaseMergeModal,
  closeLeaseMoveModal,
  closeLeaseMergeModal,
  closeLeaseEditModal,
} from '../actions';
import {
  getSelectedLease,
  getLeaseEditModal,
  getLeaseMoveModal,
  getLeaseMergeModal,
} from '../selectors';
import { enableLookupFeature } from '../../../configuration/selectors';

import { queryLeaseGQL } from '../graphql';

const mapStateToProps = (state) => {
  return {
    selectedLease: getSelectedLease(state),
    showLeaseEntryModal: getLeaseEditModal(state),
    showLeaseMoveModal: getLeaseMoveModal(state),
    showLeaseMergeModal: getLeaseMergeModal(state),
    enableLookupFeature: enableLookupFeature(state),
  };
};

const mapDispatchToProps = {
  openLeaseEditModal,
  openLeaseMoveModal,
  openLeaseMergeModal,
  closeLeaseMoveModal,
  closeLeaseMergeModal,
  closeLeaseEditModal,
};

const withRedux = connect(mapStateToProps, mapDispatchToProps);

const enhance = compose(
  queryLeaseGQL,
  withRedux,
);

export default enhance(LeaseTable);
